"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
export default function ServiceOptions() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const handleEmailClick = () => {
    window.location.href = 'mailto:aidan.bartlett.photography@gmail.com';
  };
  const services = [{
    id: 1,
    icon: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1501731/img/terra_icon_service_consulting.png",
    title: "Photography Packages",
    description: "Our wedding photography packages are designed to capture real moments as they unfold, using natural light and calm storytelling to reflect how your day truly felt. Each package offers clear coverage, timeless editing, and an experience that feels relaxed, personal, and deeply meaningful.",
    cta: "See Your Story",
    link: "#",
    ref: ref1,
    isVisible: isVisible1,
    delay: "0ms",
    isEmailTrigger: true
  }, {
    id: 2,
    icon: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1501731/img/terra_icon_service_planning.png",
    title: "Videogrpahy Packages",
    description: "Our wedding videography packages are crafted to capture real voices, natural movement, and the quiet emotion that photos cannot hold. Each film is shaped with calm storytelling and clean audio, so your wedding day can be felt again, not just remembered.",
    cta: "Watch Your Story",
    link: "#",
    ref: ref2,
    isVisible: isVisible2,
    delay: "80ms",
    isEmailTrigger: true
  }, {
    id: 3,
    icon: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1501731/img/terra_icon_service_execution.png",
    title: "Combined Packages",
    description: "Our combined wedding photo and video packages bring photography and videography together into one seamless story, capturing both the still moments and the movement in between. With one calm, experienced team, your day is documented naturally, honestly and completly",
    cta: "One Complete Story",
    link: "#",
    ref: ref3,
    isVisible: isVisible3,
    delay: "160ms",
    isEmailTrigger: false
  }];
  return <section className="py-16 px-6 bg-background">
      <div className="container mx-auto max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map(service => <div key={service.id} ref={service.ref} data-index={service.id} className="transition-all duration-700 ease-out" style={{
          opacity: service.isVisible ? 1 : 0,
          transform: service.isVisible ? "translateY(0)" : "translateY(24px)",
          transitionDelay: service.isVisible ? service.delay : "0ms"
        }}>
              <Card className="h-full bg-muted border-0 shadow-soft rounded-md transition-all duration-medium ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium group">
                <CardHeader className="pb-4">
                  <CardTitle className="text-xl font-display text-foreground">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex flex-col gap-6">
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {service.description}
                  </p>
                  <Button variant="outline" className="w-full mt-auto border-border bg-[#B86A5A] text-white hover:bg-[#A55A4A] hover:border-accent transition-all duration-fast" onClick={service.isEmailTrigger ? handleEmailClick : undefined}>
                    {service.cta}
                  </Button>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}